var map = {
	"./booost.png": 5333,
	"./burrito.png": 316,
	"./certik.png": 7777,
	"./chainlink.png": 1403,
	"./dcent.png": 7667,
	"./ghoststudio.png": 3826,
	"./haechilabs.png": 4025,
	"./handy.png": 9175,
	"./havah.png": 4979,
	"./kardiachain.png": 6985,
	"./ledger.png": 1742,
	"./likelion.png": 1543,
	"./me2on.png": 3114,
	"./me2zen.png": 5115,
	"./miracle.png": 2515,
	"./neopin.png": 2707,
	"./normainmetaland.png": 1538,
	"./oracle.png": 8759,
	"./seoganguniv.png": 2622,
	"./sevenlinelabs.png": 3148,
	"./tnt.png": 448,
	"./tomochain.png": 14,
	"./xpla.png": 7762
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 982;